import { EventBus } from "@/utils/event-bus.js";
import { getIconByDirection } from "@/utils/VehicleHelper";
function VeicleLastGps() {
  this.destroyFlag = 0; //1 表示销毁  0 表示不销毁
  this.map;
  this.marker;
  this.label;
  this.gpsInfo;
  this.vehicleInfo;

  this.init = (map, vehicleinfo) => {
    this.map = map;
    this.vehicleInfo = vehicleinfo;
  };

  this.destroy = () => {
    if (this.map && this.gpsInfo) {
        this.map.removeClustererById("v_" + this.gpsInfo.VehicleID);
      // this.map.removeMarkerById("v_" + this.vehicleInfo.VehicleID);
    }
  };

  this.updateDestroyFlag = (flag) => {
    this.destroyFlag = flag;
  };

  this.updateGps = (info) => {
    if (this.gpsInfo == undefined) {
      this.gpsInfo = Object.assign({}, info);
      
      // console.log(this.gpsInfo.Lon, this.gpsInfo.Lat);
      //可能存在map还不存在的情况


      this.map.addMarkerToCluster(
        "v_" + this.gpsInfo.VehicleID,
        this.vehicleInfo.vehicleName + "(" + this.gpsInfo.Speed + " km/h)",
        this.gpsInfo.Lon,
        this.gpsInfo.Lat,
        getIconByDirection(this.gpsInfo.Direction),
        () => {
          EventBus.$emit("showOnMapEvent", {
            gpsInfo: this.gpsInfo,
            vehicleInfo: this.vehicleInfo,
          });
        }
      );
      // console.log(this.gpsInfo.Lon, this.gpsInfo.Lat);
          this.map.setCenter(this.gpsInfo.Lon, this.gpsInfo.Lat);//这个方法会影响 MarkerClusterer
    } else {
      //判断是否需要更新

      if (this.gpsInfo.Lon != info.Lon || this.gpsInfo.Lat != info.Lat) {
        //需要更新位置
        if (this.map) {
          this.map.removeClustererById("v_" + this.gpsInfo.VehicleID);
          // this.map.removeMarkerById("v_" + this.vehicleInfo.VehicleID);
      
          this.map.addMarkerToCluster(
            "v_" + this.gpsInfo.VehicleID,
            this.vehicleInfo.vehicleName + "(" + this.gpsInfo.Speed + " km/h)",
            this.gpsInfo.Lon,
            this.gpsInfo.Lat,
            getIconByDirection(this.gpsInfo.Direction),
            () => {
              EventBus.$emit("showOnMapEvent", {
                gpsInfo: this.gpsInfo,
                vehicleInfo: this.vehicleInfo,
              });
            }
          );
            this.map.setCenter(this.gpsInfo.Lon, this.gpsInfo.Lat);
        }
      }

      this.gpsInfo = Object.assign({}, info); //info;
    }
  };
}

export { VeicleLastGps };
